import React, { Component } from "react";
import { isMobileApp } from "../../actions/Util";
import NewButton from "../2/Controls/NewButton";
import Icon from "../2/Controls/Icon";
import ListingPage from "../2/Controls/ListingPage";
import "../../components/2/Controls/ListingPage.css"

class DownloadedReports extends Component {
    constructor(props) {
        super(props);
        this.state = {
            reportsData: [],
            totalReports: "0",
            pendingReports: "0",
            completedReports: "0",
            showFilterOptions: false,
            filterSelectedOption: "All",
            loading: false,
            isMobileView: window.innerWidth < 768
        };
        this.dropdownRef = React.createRef();
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
        this.fetchData();
        
        // Add click outside listener
        document.addEventListener("mousedown", this.handleClickOutside);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.filterSelectedOption !== this.state.filterSelectedOption) {
            this.fetchData();
        }
    }

    handleResize = () => {
        const mobile = window.innerWidth < 768;
        this.setState({ isMobileView: mobile });
    }

    handleClickOutside = (event) => {
        if (this.dropdownRef.current && !this.dropdownRef.current.contains(event.target)) {
            this.setState({ showFilterOptions: false });
        }
    }

    fetchData = async () => {
        this.setState({ loading: true });
        try {
            const response = await this.props.getDownloadReports(this.props.user.user.RegistrationID);
            console.log("response", response);
            if (response && response.hasOwnProperty('code') && response.code === "0") {
                let filteredData = null;
                if (this.state.filterSelectedOption === "All") {
                    filteredData = response.reports;
                } else {
                    filteredData = response.reports.filter(report => report.status === this.state.filterSelectedOption.toLowerCase());
                }

                this.setState({ reportsData: filteredData });
                this.setState({ totalReports: filteredData.length });
                const completed = response.reports.filter(report => report.status === "completed").length;
                const pending = response.reports.filter(report => report.status === "pending").length;
                this.setState({ completedReports: completed, pendingReports: pending });
            } else {
                const errorMessage = (response && response.data && response.data.hasOwnProperty('message')) 
                    ? response.data.message 
                    : "Failed to fetch download reports data";
                console.error("Failed to fetch:", errorMessage, response);
                this.props.getToastr(errorMessage);
                this.setState({ totalReports: "0", completedReports: "0", pendingReports: "0" });
            }
        } catch (error) {
            console.error("Runtime error while fetching download reports data:", error);
            const errorMessage = (error.response && error.response.data && error.response.data.hasOwnProperty('message'))
                ? error.response.data.message
                : (error.hasOwnProperty('message') ? error.message : "An unexpected error occurred");
            this.props.getToastr(errorMessage);
            this.setState({ totalReports: "0", completedReports: "0", pendingReports: "0" });
        } finally {
            this.setState({ loading: false });
        }
    }

 

    handleOptionSelect = (value) => {
        this.setState({ 
            filterSelectedOption: value, 
            showFilterOptions: false 
        });
    }

    filterOptions = [
        { label: "All", value: "All" },
        { label: "Pending", value: "Pending" },
        { label: "Completed", value: "Completed" },
        { label: "Failed", value: "Failed" },
    ]

    render() {
        const { reportsData, loading, filterSelectedOption, showFilterOptions, isMobileView } = this.state;
        const { navigate } = this.props;
        
        return (
            <div className="header-margin">
            
                    <div
              style={{ padding: "10px"}}
            
                      className=""
                    >
            
                      <div className="listing-page-header">
            
                        <div className="left left-40">
            
                          <div className="listing-page-header-title">
            
                          Downloaded Reports
            
                          </div>
            
                        </div>
            
                       
            
                      </div>
            
                      <div
                        className="listing-page-content"
                        style={{
                          height:
                               window.innerHeight - 100 + "px",
                            // window.innerHeight - 200 + "px",
                          overflowY: "auto",
                          backgroundColor: "white"
                        }}
                      >
            
            
                       
            
                     
          
            
                  
         
                <div style={{
                    height: "100%",
                    overflowY: "auto",
                    padding: "12px",
                    backgroundColor: "rgba(255, 255, 255, 0.8)"
                }}>
                    <div>
                        <div style={{
                            width: isMobileApp() ? "100%" : "50%",
                            borderRadius: "8px",
                            backgroundColor: "rgba(255, 255, 255, 0.8)",
                            paddingBottom: "4px",
                            boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)"
                        }}>
                            {/* Header Section */}
                            <div style={{
                                display: "flex",
                                flexDirection: isMobileView ? "column" : "row",
                                justifyContent: "space-between",
                                alignItems: isMobileView ? "flex-start" : "center",
                                backgroundColor: "#eff6ff",
                                borderBottom: "1px solid #f3e8ff",
                                padding: isMobileView ? "12px 16px" : "16px 24px",
                                borderTopLeftRadius: "8px",
                                borderTopRightRadius: "8px"
                            }}>
                                <span style={{
                                    fontWeight: "600",
                                    marginBottom: isMobileView ? "8px" : "0"
                                }}>Downloaded Reports</span>

                                <div style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px"
                                }}>
                                    <span 
                                        style={{
                                            width: "20px",
                                            marginRight: isMobileView ? "4px" : "12px",
                                            color: "#6b7280",
                                            cursor: "pointer"
                                        }}
                                        onClick={() => { this.fetchData() }}
                                    >
                                        <Icon type="refresh" />
                                    </span>

                                    <div style={{ position: "relative" }} ref={this.dropdownRef}>
                                        <button
                                            onClick={() => this.setState({ showFilterOptions: !showFilterOptions })}
                                            style={{
                                                color: "#374151",
                                                backgroundColor: "white",
                                                border: "1px solid #e5e7eb",
                                                height: "34px",
                                                padding: "0 12px",
                                                cursor: "pointer",
                                                borderRadius: "8px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                fontWeight: "bold"
                                            }}
                                        >
                                            {!isMobileView && "Filter By: "}
                                            <span style={{
                                                paddingLeft: "4px",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                maxWidth: isMobileView ? "80px" : "none"
                                            }}>{filterSelectedOption}</span>
                                            <span style={{
                                                width: "10px",
                                                display: "inline-flex",
                                                marginBottom: "2px",
                                                marginLeft: "4px"
                                            }}>
                                                <Icon type="downarrownew" />
                                            </span>
                                        </button>

                                        {showFilterOptions && (
                                            <div
                                                style={{
                                                    position: "absolute",
                                                    zIndex: 10,
                                                    marginTop: "6px",
                                                    borderRadius: "8px",
                                                    boxShadow: "0 2px 10px rgba(215, 213, 226, 0.5), 0 4px 6px rgba(0, 0, 0, 0.1)",
                                                    backgroundColor: "white",
                                                    width: isMobileView ? "100%" : "auto",
                                                    right: 0,
                                                    minWidth: "150px"
                                                }}
                                            >
                                                {this.filterOptions.map((option, index) => (
                                                    <div
                                                        key={index}
                                                        onClick={() => this.handleOptionSelect(option.value)}
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "space-between",
                                                            padding: "8px",
                                                            cursor: "pointer",
                                                            backgroundColor: filterSelectedOption === option.value ? "#F5EBFB" : "white",
                                                            color: filterSelectedOption === option.value ? "#6e2d90" : "inherit"
                                                        }}
                                                        onMouseEnter={(e) => {
                                                            if (filterSelectedOption !== option.value) {
                                                                e.currentTarget.style.backgroundColor = "#6E2D90";
                                                                e.currentTarget.style.color = "white";
                                                            }
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            if (filterSelectedOption !== option.value) {
                                                                e.currentTarget.style.backgroundColor = "white";
                                                                e.currentTarget.style.color = "inherit";
                                                            }
                                                        }}
                                                    >
                                                        <span style={{ overflow: "hidden", textOverflow: "ellipsis" }}>{option.label}</span>
                                                        {filterSelectedOption === option.value && (
                                                            <span style={{ width: "12px", color: "#6e2d90", marginLeft: "8px" }}>
                                                                <Icon type="check" />
                                                            </span>
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* Content Section */}
                            {loading ? (
                                <div style={{
                                    color: "#6b7280",
                                    padding: "20px",
                                    display: "flex",
                                    justifyContent: "center"
                                }}>Loading...</div>
                            ) : (
                                <>
                                    {reportsData.length > 0 ? (
                                        <div style={{ marginTop: "4px", padding: "8px 0" }}>
                                            {reportsData.map((report, index) => (
                                                <div
                                                    key={index}
                                                    style={{
                                                        backgroundColor: "white",
                                                        padding: isMobileView ? "12px 16px" : "16px 24px",
                                                        borderBottom: index !== reportsData.length - 1 ? "1px solid #f3e8ff" : "none"
                                                    }}
                                                >
                                                    <div style={{
                                                        display: "flex",
                                                        flexDirection: isMobileView ? "column" : "row",
                                                        alignItems: isMobileView ? "stretch" : "flex-start",
                                                        gap: isMobileView ? "12px" : "16px"
                                                    }}>
                                                        {/* Left side - File type and report info */}
                                                        <div style={{
                                                            display: "flex",
                                                            alignItems: "flex-start",
                                                            gap: "12px",
                                                            flex: 1
                                                        }}>
                                                            <div style={{ flexShrink: 0 }}>
                                                                <span style={{
                                                                    fontSize: "12px",
                                                                    fontWeight: "500",
                                                                    padding: "8px",
                                                                    borderRadius: "8px",
                                                                    display: "inline-flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    backgroundColor: report.format === "csv" ? "#d1fae5" : report.format === "pdf" ? "#fee2e2" : "#fef3c7",
                                                                    color: report.format === "csv" ? "#065f46" : report.format === "pdf" ? "#991b1b" : "#92400e"
                                                                }}>
                                                                    {report.format === "CSV" ? "CSV" : report.format === "excel" ? "XLS" : "PDF"}
                                                                </span>
                                                            </div>

                                                            <div style={{ flex: 1, minWidth: 0 }}>
                                                                <div style={{
                                                                    fontWeight: "600",
                                                                    overflow: "hidden",
                                                                    textOverflow: "ellipsis",
                                                                    whiteSpace: "nowrap"
                                                                }}>{report.reportName}</div>
                                                                <div style={{
                                                                    fontSize: "14px",
                                                                    color: report.status === "completed" ? "#16a34a" : report.status === "failed" ? "#991b1b" : "#6b7280"
                                                                }}>
                                                                    {report.status === "completed" && "Ready to download"}
                                                                    {report.status === "pending" && "Work in progress..."}
                                                                    {report.status === "failed" && `Error: ${report.error}`}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Middle - Timestamps */}
                                                        <div style={{ display: "flex", flexDirection: "column" }}>
                                                            <div style={{ color: "#6b7280" }}>
                                                                <span style={{ color: "#6b7280" }}>Requested: </span>
                                                                <span style={{
                                                                    whiteSpace: "nowrap",
                                                                    color: "#000000"
                                                                }}>
                                                                    {new Date(report.createdAt).toLocaleString()}
                                                                </span>
                                                            </div>
                                                            {report.completedAt && (
                                                                <div style={{ color: "#6b7280" }}>
                                                                    <span style={{ color: "#6b7280" }}>Completed: </span>
                                                                    <span style={{
                                                                        whiteSpace: "nowrap",
                                                                        color: "#000000"
                                                                    }}>
                                                                        {new Date(report.completedAt).toLocaleString()}
                                                                    </span>
                                                                </div>
                                                            )}
                                                        </div>

                                                        {/* Right side - Download button */}
                                                        <div style={{ flexShrink: 0 }}>
                                                            {report.status == "completed" && <NewButton
                                                            
                                                                disabled={report.status !== "completed"}
                                                                onClick={() => {
                                                                    if (report.status === "completed") {
                                                                        const link = document.createElement('a');
                                                                        link.href = `${report.downloadUrl}`;
                                                                        link.download = report.reportName || `report.${report.format}`;
                                                                        document.body.appendChild(link);
                                                                        link.click();
                                                                        document.body.removeChild(link);
                                                                    }
                                                                }}
                                                                type="primary"
                                                                text="Download"
                                                            />}
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <div style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            padding: "24px",
                                            color: "#6b7280"
                                        }}>
                                            No reports found
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                </div>
                 </div>
                 <div className="listing-page-footer">

                 </div>
                  </div>
            
                  </div>
        );
    }
}

export default DownloadedReports;